import React from "react";

export const DashboardContext = React.createContext({
  registerReload: () => null,
  unregisterReload: () => null,
});
